export default {"src":"/_next/static/media/science.049b8eae.svg","height":78,"width":132};